import { useRentalManagerUserPropertyMultiplexWebApiHandler_unarchive } from '@zg-rentals/ts-rental-manager-api-client-react-query';

import { DEFAULT_ARCHIVE_INVALIDATES } from '../../../constants/InvalidateConstants';

import type { MutateOptions } from '@zg-rentals/react-query5';
import type { RentalManagerUserPropertyMultiplexWebApiHandler_unarchive_Args } from '@zg-rentals/ts-rental-manager-api-client-react-query';

type UnarchiveMultiplexPropertyOptions = Parameters<
  typeof useRentalManagerUserPropertyMultiplexWebApiHandler_unarchive
>[0];

type UnarchiveMultiplexPropertyMutateOptions = MutateOptions<
  void,
  unknown,
  RentalManagerUserPropertyMultiplexWebApiHandler_unarchive_Args
>;

/**
 * Unarchives all units in a multiplex property via /api/web/v1/users/properties/multiplex/unarchive.
 *
 * Merges default `meta.invalidates` (plus any `meta.invalidates` you pass) and sets `meta.context`
 * for logging unless overridden.
 */
export const useUnarchiveMultiplexProperty = (options: UnarchiveMultiplexPropertyOptions = {}) => {
  const { meta: metaOverrides, ...restOptions } = options;

  const mutation = useRentalManagerUserPropertyMultiplexWebApiHandler_unarchive({
    ...restOptions,
    meta: {
      ...metaOverrides,
      invalidates: [...DEFAULT_ARCHIVE_INVALIDATES, ...(metaOverrides?.invalidates ?? [])],
      context: {
        api: 'unarchive',
        details: 'useUnarchiveMultiplexProperty',
        ...metaOverrides?.context,
      },
    },
  });

  const unarchiveMultiplexProperty = (groupId: string, mutateOptions?: UnarchiveMultiplexPropertyMutateOptions) =>
    mutation.mutate({ postData: { groupId } }, mutateOptions);

  return { ...mutation, unarchiveMultiplexProperty };
};
